import React from 'react'
import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilState } from 'recoil'
import DynamicFieldItem, {
  SECTION
} from 'Components/DynamicFiledItem/DynamicFieldItem'
import { modalCheckupState } from 'Components/ModalCheckup/recoil/state'
import { sendingMessageCallback } from 'Pages/OverviewMessage/recoil/callbacks/callbacks'
import { MESSAGE_STR_TYPE_CONTENTSCAMPAIGN } from 'Constants/'
import { notifyParent } from 'Helpers/notifyParent'
import { useHistory } from 'react-router-dom'
import PropTypes from 'prop-types'
import { ICON_ALERT } from 'Components/CheckItem/CheckItem'
import { Link, LINK_VARIANT_EXTRALIGHT } from 'mailup-web-components'

const DynamicFieldBody = ({
  idMessage,
  isBee,
  messageType,
  idCampaign,
  wrongDynamicTagsGroup
}) => {
  const intl = useIntl()
  const [
    { dynamicFieldsOptionEnabled, addToWhiteList },
    setModalState
  ] = useRecoilState(modalCheckupState)
  const isSendingMessage = useRecoilCallback(sendingMessageCallback, [])
  const history = useHistory()

  const handleClick = (e, section) => {
    e.stopPropagation()
    e.preventDefault()

    isSendingMessage(idMessage).then(isSending => {
      if (!isSending) {
        if (isBee && messageType === MESSAGE_STR_TYPE_CONTENTSCAMPAIGN) {
          notifyParent('redirectMainFrame', [
            `App.aspx#/beePluginEditor/editCMP/${idCampaign}`
          ])
        }
        if (isBee && messageType !== MESSAGE_STR_TYPE_CONTENTSCAMPAIGN) {
          history.push(`/messages/email/bee/edit/${idMessage}`)
        }
        if (!isBee) {
          notifyParent('redirectMainFrame', [
            `form_upd_newsletter.aspx?source=listemail&idNL=${idMessage}`
          ])
        }
      } else {
        setModalState(prev => ({
          ...prev,
          show: false,
          showModalBeingSent: true
        }))
      }
    })
  }

  return (
    <>
      {wrongDynamicTagsGroup && 'Body' in wrongDynamicTagsGroup && (
        <>
          <DynamicFieldItem
            section={SECTION.body}
            items={wrongDynamicTagsGroup.Body}
            intl={intl}
            badge={
              !dynamicFieldsOptionEnabled
                ? intl.formatMessage({ id: 'Load.EmailCheckUp.WarningLabel' })
                : ''
            }
            icon={!dynamicFieldsOptionEnabled ? ICON_ALERT : ''}
            title={
              'Subject' in wrongDynamicTagsGroup ||
              'Preheader' in wrongDynamicTagsGroup
                ? ''
                : intl.formatMessage({
                    id: 'Load.EmailCheckUp.SecntionDynamicFields'
                  })
            }
            description={intl.formatMessage(
              {
                id: 'Load.EmailCheckUp.DynamicFieldsBodyTitleIntl'
              },
              {
                link: e => (
                  <Link
                    variant={LINK_VARIANT_EXTRALIGHT}
                    key={1}
                    onClick={e => handleClick(e, SECTION.body)}
                  >
                    {e}
                  </Link>
                )
              }
            )}
            setModalState={setModalState}
            addToWhiteList={addToWhiteList}
          />
        </>
      )}
    </>
  )
}

DynamicFieldBody.propTypes = {
  messageType: PropTypes.any,
  isBee: PropTypes.bool,
  idMessage: PropTypes.number,
  idCampaign: PropTypes.number,
  wrongDynamicTagsGroup: PropTypes.any
}

export default DynamicFieldBody
